/**
 * Turns a string into a URL-safe slug.
 *
 * ```
 * slugify("About Me") // "about-me"
 * ```
 *
 * @param {String}
 * @returns {String}
 */
export function slugify(string = "") {
  return string
    .trim()
    .toLowerCase()
    .replaceAll("/", "-")
    .replaceAll(" ", "-")
}
